<template> 
  <div>
    <CRow>
        <CCol sm="6" md="4">
            <CCard>
            <CCardHeader>Set Content Position</CCardHeader>
            <CCardBody>
            <!-- <CRow>
                <CCol md="4"><CCard borderColor="white"><CCardBody>Position</CCardBody></CCard></CCol>
            </CRow> -->
            <CRow>
                <!-- <CCol md="2"><CCard v-for="(list,index) in form.list1" :key="index" borderColor="white" align="center"><CCardBody>{{ index+1 }}</CCardBody></CCard></CCol> -->
                <CCol md="8">
                    <draggable
                        tag="ul"
                        group="all-users"
                        class="draggable-list"
                        ghost-class="moving-card"
                        filter=".action-button"
                        :list="form.list1"
                        :animation="200"
                        :move="onMove"
                    >
                        <CCard v-for="(list,index) in form.list1" :key="index" align="center">
                          <!-- <i :class="list.fixed == 0? 'fa fa-anchor' : 'glyphicon glyphicon-pushpin'" @click=" list.fixed=! list.fixed" aria-hidden="true">xx {{ list.fixed }} xx</i> -->
                          <table>
                            <tr>
                              <td>{{ index+1 }}</td>
                              <td><CButton :class="list.fixed == 0? 'btn btn-sm btn-success' : 'btn btn-sm btn-danger'" @click=" list.fixed=! list.fixed"></CButton></td>
                              <td>{{ list.name }}</td>
                              <td><CButton class="btn btn-sm btn-info" @click="showList(list.id)">Show List</CButton></td>
                            </tr>  
                          </table>  
                        </CCard>
                    </draggable>
                </CCol>
            </CRow>
            <CButton color="info" block size="sm" variant="outline" type="submit" v-on:click.prevent="sort()">Set</CButton>
            </CCardBody>
            </CCard>            
        </CCol>
        <!-- <CCol sm="2" md="4">
            <CCard>
            <CCardHeader>Example Position Layout</CCardHeader>
            <CCardBody>
            <CRow>
                <CCol md="2"><CCard v-for="(list,index) in lay1" :key="index" align="center"><CCardBody>{{ list.n }}</CCardBody></CCard></CCol>
                <CCol md="2"><CCard v-for="(list,index) in lay2" :key="index" align="center"><CCardBody>{{ list.n }}</CCardBody></CCard></CCol>
            </CRow>
            </CCardBody>
            </CCard>            
        </CCol> -->
    </CRow>
<alertmodal></alertmodal>
<!-- <pre>{{ $data }}</pre> -->

  </div>
</template>

<script>
import EventBus from '@/eventBus';
import alertmodal from '@/views/alert/modal.vue';

import section from '@/services/section'

import Draggable from "vuedraggable";


export default {
name: 'sectionorder',
  components: {
    Draggable,
    alertmodal
  },
  data () {
    return {

      list1: [],
      list2: [],
      lay1: [{n:"1"},{n:"3"},{n:"5"},{n:"7"},{n:"9"},],
      lay2: [{n:"2"},{n:"4"},{n:"6"},{n:"8"},{n:"10"},],
      show: false,
      title: 'Default Title',
      mode: '',
      form:{
          list1: []
      },
   
      
    }
  },
   computed: {

   },
  mounted(){
    
  },
  created () {
    var self = this;

    section.getSectionOrderList()
    .then(res => {
        self.form.list1 = res.list;
    }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
    })


  },

  

  methods: {
    sort(){
        for (let i=0; i <= this.form.list1.length-1; i++){
            this.form.list1[i].new_pos = i+1;
        }

        section.updateSectionOrderList(this.form)
        .then(res => {
            var params = {title: 'Success', mode:'success', data:res.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
            var params = {title: 'Error', mode:'danger', data:err.response.data.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
    },
    checkMove: function(evt){
      console.log(evt.draggedContext.index);
        return (evt.draggedContext.index!==1);
    },
    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      );
    },
    showList(id){
      this.$router.push({name:'Link Content Order',query: {section:id} })
    }
  }
}
</script>


<style>
.draggable-list {
  min-height: 100px;
}
/* Unfortunately @apply cannot be setup in codesandbox, 
but you'd use "@apply border opacity-50 border-blue-500 bg-gray-200" here */
.moving-card {
  opacity: 0.5;
  background: #F7FAFC;
  border: 1px solid #4299e1;
}
</style>